(function () {
  'use strict';

  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  var DESKTOP_POINTER_QUERY = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  var TABLET_TOUCH_QUERY = window.matchMedia('(min-width: 750px) and (hover: none), (min-width: 750px) and (pointer: coarse)');
  var PANEL_SELECTOR = 'section.okd-portal .portal__left';
  var OVERLAY_ID = 'okd-portal__overlay';
  var REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');
  var timers = [];
  var overlayObserver = null;
  var cueFrame = null;
  var cueScrollCleanup = null;
  var mobileSequenceActive = false;
  var userInterrupted = false; var mobileIntroPlayed = false;

  function clearTimers() {
    timers.forEach(function (timer) { window.clearTimeout(timer); });
    timers = [];
  }

  function cancelCueFrame() {
    if (cueFrame !== null) {
      window.cancelAnimationFrame(cueFrame);
      cueFrame = null;
    }
    if (cueScrollCleanup) {
      cueScrollCleanup();
      cueScrollCleanup = null;
    }
  }

  function later(fn, delay) {
    timers.push(window.setTimeout(fn, delay));
  }

  function getParts() {
    var panel = document.querySelector(PANEL_SELECTOR);
    if (!panel) return null;
    var section = panel.closest('section.okd-portal');
    return {
      panel: panel,
      section: section,
      video: panel.querySelector('.portal__left-visual video'),
      xposure: section ? section.querySelector('.portal__right') : null,
      xposureVisual: section ? section.querySelector('.portal__right-visual') : null
    };
  }

  function ensureMobileIntro(parts) {
    if (!parts || !parts.section || !MOBILE_QUERY.matches) return null;
    var existing = parts.section.querySelector('.kfa-mobile-house-intro');
    if (existing) return existing;

    var intro = document.createElement('div');
    intro.className = 'kfa-mobile-house-intro';
    intro.hidden = true;
    intro.setAttribute('role', 'img');
    intro.setAttribute('aria-label', 'KAYSER Fine Arts. One house. Two worlds. Same obsession.');

    var inner = document.createElement('div');
    inner.className = 'kfa-mobile-house-intro__inner';
    var sourceLogo = parts.section.querySelector('.portal__logo');
    if (sourceLogo) {
      var logo = sourceLogo.cloneNode(true);
      logo.className = 'kfa-mobile-house-intro__logo';
      logo.removeAttribute('id');
      Array.prototype.forEach.call(logo.querySelectorAll('[id]'), function (node) {
        node.removeAttribute('id');
      });
      logo.setAttribute('aria-hidden', 'true');
      inner.appendChild(logo);
    }

    var statement = document.createElement('p');
    statement.className = 'kfa-mobile-house-intro__statement';
    statement.setAttribute('aria-hidden', 'true');
    var one = document.createElement('span');
    one.className = 'kfa-mobile-house-intro__one';
    one.textContent = 'ONE HOUSE.'; var separator = document.createElement('br');
    separator.className = 'kfa-mobile-house-intro__separator'; var two = document.createElement('span');
    two.className = 'kfa-mobile-house-intro__two';
    separator.textContent = ''; two.textContent = 'TWO WORLDS.'; var obsession = document.createElement('span'); obsession.className = 'kfa-mobile-house-intro__obsession'; obsession.textContent = 'SAME OBSESSION.';
    statement.appendChild(one); statement.appendChild(separator);
    statement.appendChild(two); statement.appendChild(obsession);
    inner.appendChild(statement);
    intro.appendChild(inner);
    parts.section.appendChild(intro);
    return intro;
  }

  function resetMobileIntro(parts) {
    var intro = parts && parts.section ? parts.section.querySelector('.kfa-mobile-house-intro') : null;
    document.documentElement.classList.remove('kfa-mobile-house-intro-active');
    if (!intro) return;
    intro.classList.remove('is-active', 'is-one-visible', 'is-two-visible', 'is-obsession-visible', 'is-look-visible', 'is-leaving');
    intro.hidden = true;
  }

  function playMobileIntro(parts, onComplete) {
    var intro = ensureMobileIntro(parts);
    if (!intro) { onComplete(); return; }
    resetMobileIntro(parts);
    intro.hidden = false;
    document.documentElement.classList.add('kfa-mobile-house-intro-active'); intro.getBoundingClientRect();
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { intro.classList.add('is-active'); }); });

    function finish() {
      intro.classList.add('is-leaving');
      later(function () {
        intro.hidden = true;
        intro.classList.remove('is-active', 'is-leaving');
        document.documentElement.classList.remove('kfa-mobile-house-intro-active');
        onComplete();
      }, REDUCED_MOTION_QUERY.matches ? 20 : 1250);
    }

    if (REDUCED_MOTION_QUERY.matches) {
      intro.classList.add('is-one-visible', 'is-two-visible', 'is-obsession-visible', 'is-look-visible');
      later(finish, 800);
      return;
    }
    later(function () { intro.classList.add('is-one-visible'); }, 350);
    later(function () { intro.classList.add('is-two-visible'); }, 1500); later(function () { intro.classList.add('is-obsession-visible'); }, 2650); later(function () { intro.classList.add('is-look-visible'); }, 3800);
    later(finish, 5000);
  }

  function ensureMobileSequenceStyles() {
    if (document.getElementById('kfa-mobile-sequence-timing-style')) return;
    var style = document.createElement('style');
    style.id = 'kfa-mobile-sequence-timing-style';
    style.textContent =
      '@media only screen and (max-width:749px){' +
      'section.okd-portal .portal__left .portal__left-visual,' +
      'section.okd-portal .portal__left::after{' +
      'transition:opacity 2.25s cubic-bezier(.37,0,.63,1)!important}' +
      'section.okd-portal .portal__left .portal__left-headline svg *,' +
      'section.okd-portal .portal__logo svg path{' +
      'transition:fill 1.5s cubic-bezier(.37,0,.63,1)!important}' +
      'section.okd-portal .portal__left .portal__left-headline img,' +
      'section.okd-portal .portal__logo img{' +
      'transition:filter 1.5s cubic-bezier(.37,0,.63,1)!important}' +
      'section.okd-portal .portal__left .portal__left-copy .portal__left-claim,' +
      'section.okd-portal .portal__left .portal__left-copy .portal__left-description,' +
      'section.okd-portal .portal__left .portal__left-copy .portal__left-link--inline{' +
      'transform:none!important}' +
      'section.okd-portal .portal__left .portal__left-copy .portal__left-claim{' +
      'transition:opacity 1.8s cubic-bezier(.37,0,.63,1)!important}' +
      'section.okd-portal .portal__left .portal__left-copy .portal__left-description,' +
      'section.okd-portal .portal__left .portal__left-copy .portal__left-link--inline{' +
      'transition:opacity 1.35s cubic-bezier(.37,0,.63,1)!important}' +
      'section.okd-portal .portal__left.kfa-mobile-claim-visible .portal__left-copy{' +
      'opacity:1!important;visibility:visible!important}' +
      'section.okd-portal .portal__left.kfa-mobile-claim-visible .portal__left-claim,' +
      'section.okd-portal .portal__left.kfa-mobile-description-visible .portal__left-description,' +
      'section.okd-portal .portal__left.kfa-mobile-link-visible .portal__left-link--inline{' +
      'transition-delay:0s!important}' +
      '}';
    document.head.appendChild(style);
  }

  function safelyPlay(video, restart) {
    if (!video) return;
    try {
      if (restart && Number.isFinite(video.duration)) video.currentTime = 0;
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(function () {});
    } catch (error) {}
  }

  function resetMobile(parts) {
    if (!parts) return;
    clearTimers();
    cancelCueFrame();
    mobileSequenceActive = false;
    userInterrupted = false;
    resetMobileIntro(parts);
    parts.panel.classList.remove(
      'kfa-mobile-sequence-started',
      'kfa-mobile-transitioned',
      'kfa-mobile-claim-visible',
      'kfa-mobile-description-visible',
      'kfa-mobile-link-visible'
    );
    if (parts.section) {
      parts.section.classList.remove(
        'kfa-mobile-sequence-started',
        'kfa-mobile-transitioned',
        'kfa-mobile-claim-visible',
        'kfa-mobile-description-visible',
        'kfa-mobile-link-visible'
      );
    }
    delete parts.panel.dataset.kfaMobileSequenceDone;
  }

  function addPhase(parts, className) {
    parts.panel.classList.add(className);
    if (parts.section) parts.section.classList.add(className);
  }

  function mobileConsentIsActive(parts) {
    if (!parts || !parts.section) return false;
    var banner = parts.section.querySelector('#kfa-consent-banner');
    if (!banner) return false;
    return !banner.hasAttribute('hidden');
  }

  function noteUserIntent() {
    if (!mobileSequenceActive) return;
    userInterrupted = true;
    mobileSequenceActive = false;
    cancelCueFrame();
  }

  function revealXposureEdge(parts) {
    if (!parts || !parts.panel || !parts.xposure || !MOBILE_QUERY.matches) return;
    if (userInterrupted || REDUCED_MOTION_QUERY.matches || document.visibilityState === 'hidden') {
      mobileSequenceActive = false;
      return;
    }
    if (parts.panel.dataset.kfaMobileCueDone === '1') {
      mobileSequenceActive = false;
      return;
    }

    var panelTop = parts.panel.getBoundingClientRect().top + window.pageYOffset;
    var currentY = window.pageYOffset;

    /* Never take over after the visitor has begun navigating independently. */
    if (Math.abs(currentY - panelTop) > 24) {
      mobileSequenceActive = false;
      return;
    }

    var xposureTop = parts.xposure.getBoundingClientRect().top + currentY;
    var targetY = xposureTop - (window.innerHeight * 0.74);

    /* Prefer a content-based target: stop only after at least half of the
       current XPOSURE artwork is inside the viewport. The fallback keeps the
       earlier edge cue on pages that do not contain an artwork visual. */
    if (parts.xposureVisual) {
      var visualRect = parts.xposureVisual.getBoundingClientRect();
      if (visualRect.height > 0) {
        var visualTop = visualRect.top + currentY;
        targetY = visualTop + (visualRect.height * 0.5) - window.innerHeight;
      }
    }
    targetY = Math.max(panelTop, targetY);
    var distance = targetY - currentY;
    if (distance < 24) {
      mobileSequenceActive = false;
      return;
    }

    parts.panel.dataset.kfaMobileCueDone = '1';

    /* The theme has global smooth scrolling. Leaving it enabled would start a
       second browser animation for every requestAnimationFrame update and
       make the path visibly stutter. Let this single curve own the motion. */
    var root = document.documentElement;
    var body = document.body;
    var previousRootScrollBehavior = root.style.scrollBehavior;
    var previousBodyScrollBehavior = body ? body.style.scrollBehavior : '';
    root.style.scrollBehavior = 'auto';
    if (body) body.style.scrollBehavior = 'auto';
    cueScrollCleanup = function () {
      root.style.scrollBehavior = previousRootScrollBehavior;
      if (body) body.style.scrollBehavior = previousBodyScrollBehavior;
    };

    function finishCue() {
      mobileSequenceActive = false;
      if (cueScrollCleanup) {
        cueScrollCleanup();
        cueScrollCleanup = null;
      }
    }

    function animateScroll(fromY, toY, duration, onComplete) {
      var startedAt = null;

      function step(timestamp) {
        if (userInterrupted || !MOBILE_QUERY.matches) {
          cueFrame = null;
          finishCue();
          return;
        }
        if (startedAt === null) startedAt = timestamp;

        var progress = Math.min(1, (timestamp - startedAt) / duration);

        /* Quintic smootherstep: velocity and acceleration both start and end
           at zero. This removes the perceptible kick and braking edge of a
           conventional ease-out and gives the camera move a liquid glide. */
        var eased = progress * progress * progress *
          (progress * ((progress * 6) - 15) + 10);
        window.scrollTo(0, fromY + ((toY - fromY) * eased));

        if (progress < 1) {
          cueFrame = window.requestAnimationFrame(step);
        } else {
          cueFrame = null;
          if (onComplete) onComplete();
        }
      }

      cueFrame = window.requestAnimationFrame(step);
    }

    animateScroll(currentY, currentY + distance, 1700, function () {
      /* Let XPOSURE register, then return quietly to the untouched ATELI'R
         starting position. Any visitor input during the pause keeps control. */
      later(function () {
        if (userInterrupted || !MOBILE_QUERY.matches) {
          finishCue();
          return;
        }
        animateScroll(window.pageYOffset, currentY, 1700, function () {
          finishCue();
        });
      }, 1400);
    });
  }

  function runMobileSequence(parts) {
    if (!parts || !MOBILE_QUERY.matches || parts.panel.dataset.kfaMobileSequenceDone === '1' || mobileIntroPlayed) return;
    if (mobileConsentIsActive(parts)) return;

    mobileIntroPlayed = true; parts.panel.dataset.kfaMobileSequenceDone = '1';
    mobileSequenceActive = true;
    userInterrupted = false;
    resetMobileIntro(parts);

    playMobileIntro(parts, function () {
      if (!MOBILE_QUERY.matches) return;
      addPhase(parts, 'kfa-mobile-sequence-started');
      safelyPlay(parts.video, true);
      later(function () { addPhase(parts, 'kfa-mobile-transitioned'); }, 1700);
      later(function () { addPhase(parts, 'kfa-mobile-claim-visible'); }, 2000);
      later(function () { addPhase(parts, 'kfa-mobile-description-visible'); }, 3400);
      later(function () { addPhase(parts, 'kfa-mobile-link-visible'); }, 4600);
      later(function () { revealXposureEdge(parts); }, 6200);
    });
  }

  function waitForInlineWordmark(parts, callback) {
    if (!parts || !callback) return;
    if (parts.panel.querySelector('.portal__left-headline svg')) {
      callback();
      return;
    }

    var done = false;
    var observer = new MutationObserver(function () {
      if (!done && parts.panel.querySelector('.portal__left-headline svg')) {
        done = true;
        observer.disconnect();
        window.clearTimeout(fallback);
        callback();
      }
    });
    observer.observe(parts.panel, { childList: true, subtree: true });

    var fallback = window.setTimeout(function () {
      if (done) return;
      done = true;
      observer.disconnect();
      callback();
    }, 1100);
  }

  function startMobileWhenPortalVisible(parts) {
    if (!parts || !MOBILE_QUERY.matches || mobileIntroPlayed) return; if (!mobileConsentIsActive(parts)) { runMobileSequence(parts); return; }

    if (overlayObserver) {
      overlayObserver.disconnect();
      overlayObserver = null;
    }

    var overlay = document.getElementById(OVERLAY_ID);
    if (!overlay) {
      later(function () {
        waitForInlineWordmark(parts, function () { runMobileSequence(parts); });
      }, 180);
      return;
    }

    function overlayHasCleared() {
      var current = document.getElementById(OVERLAY_ID);
      return !current || current.classList.contains('okd-overlay--hiding');
    }

    function begin() {
      if (overlayObserver) {
        overlayObserver.disconnect();
        overlayObserver = null;
      }
      later(function () {
        waitForInlineWordmark(parts, function () { runMobileSequence(parts); });
      }, 180);
    }

    if (overlayHasCleared()) {
      begin();
      return;
    }

    overlayObserver = new MutationObserver(function () {
      if (overlayHasCleared()) begin();
    });
    overlayObserver.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function bindDesktop(parts) {
    if (!parts || parts.panel.dataset.kfaDesktopBound === '1') return;
    parts.panel.dataset.kfaDesktopBound = '1';

    function activate() {
      if (!DESKTOP_POINTER_QUERY.matches) return;
      parts.panel.classList.add('kfa-desktop-reveal');
      if (parts.section) parts.section.classList.add('kfa-desktop-reveal');
      safelyPlay(parts.video, true);
    }

    function deactivate(event) {
      if (!DESKTOP_POINTER_QUERY.matches) return;
      if (event && event.type === 'focusout' && parts.panel.contains(event.relatedTarget)) return;
      parts.panel.classList.remove('kfa-desktop-reveal');
      if (parts.section) parts.section.classList.remove('kfa-desktop-reveal');
    }

    parts.panel.addEventListener('pointerenter', activate, { passive: true });
    parts.panel.addEventListener('pointerleave', deactivate, { passive: true });
    parts.panel.addEventListener('focusin', activate);
    parts.panel.addEventListener('focusout', deactivate);
  }

  /* Tablets do not have a dependable hover state. The first tap therefore
     reveals the approved ATELI'R copy; a second tap follows the existing link.
     Mouse/trackpad desktop and the independent mobile sequence stay untouched. */
  function bindTabletTouch(parts) {
    if (!parts || parts.panel.dataset.kfaTabletTouchBound === '1') return;

    var hitarea = parts.panel.querySelector('.portal__left-hitarea');
    if (!hitarea) return;

    parts.panel.dataset.kfaTabletTouchBound = '1';

    function deactivate() {
      parts.panel.classList.remove('active', 'kfa-tablet-touch-active');
      var logo = parts.section ? parts.section.querySelector('.portal__logo') : null;
      if (logo) logo.classList.remove('active');
    }

    hitarea.addEventListener('click', function (event) {
      if (!TABLET_TOUCH_QUERY.matches) return;
      if (parts.panel.classList.contains('kfa-tablet-touch-active')) return;

      event.preventDefault();
      parts.panel.classList.add('active', 'kfa-tablet-touch-active');
      var logo = parts.section ? parts.section.querySelector('.portal__logo') : null;
      if (logo) logo.classList.add('active');
      safelyPlay(parts.video, true);
    });

    document.addEventListener('pointerdown', function (event) {
      if (!TABLET_TOUCH_QUERY.matches || parts.panel.contains(event.target)) return;
      deactivate();
    }, true);
  }

  function resetTabletTouch(parts) {
    if (!parts || TABLET_TOUCH_QUERY.matches) return;
    parts.panel.classList.remove('active', 'kfa-tablet-touch-active');
    var logo = parts.section ? parts.section.querySelector('.portal__logo') : null;
    if (logo) logo.classList.remove('active');
  }

  function init() {
    var parts = getParts();
    if (!parts) return;

    ensureMobileSequenceStyles();
    bindDesktop(parts);
    bindTabletTouch(parts);
    resetTabletTouch(parts);

    if (MOBILE_QUERY.matches) { if (mobileIntroPlayed) return;
      resetMobile(parts);
      startMobileWhenPortalVisible(parts);
    } else {
      resetMobile(parts);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.addEventListener('pageshow', function (event) {
    var parts = getParts();
    if (!parts) return;
    if (MOBILE_QUERY.matches && event.persisted) resetMobile(parts);
    if (MOBILE_QUERY.matches) startMobileWhenPortalVisible(parts);
  });

  document.addEventListener('kfa:consent-resolved', function () {
    var parts = getParts();
    if (!parts || !MOBILE_QUERY.matches || mobileIntroPlayed) return; if (!mobileConsentIsActive(parts)) { runMobileSequence(parts); return; }
    resetMobile(parts);
    later(function () { runMobileSequence(parts); }, 0);
  });

  /* Touch and wheel are the actual mobile navigation intents. A generic
     pointerdown is deliberately excluded: browsers can synthesize it around
     the consent control after the choice and thereby cancel the return trip. */
  ['touchstart', 'wheel'].forEach(function (type) {
    window.addEventListener(type, noteUserIntent, { passive: true, capture: true });
  });

  window.addEventListener('keydown', function (event) {
    if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].indexOf(event.key) !== -1) {
      noteUserIntent();
    }
  }, true);

  function onBreakpointChange() { init(); }
  if (typeof MOBILE_QUERY.addEventListener === 'function') {
    MOBILE_QUERY.addEventListener('change', onBreakpointChange);
  } else if (typeof MOBILE_QUERY.addListener === 'function') {
    MOBILE_QUERY.addListener(onBreakpointChange);
  }
  if (typeof TABLET_TOUCH_QUERY.addEventListener === 'function') {
    TABLET_TOUCH_QUERY.addEventListener('change', onBreakpointChange);
  } else if (typeof TABLET_TOUCH_QUERY.addListener === 'function') {
    TABLET_TOUCH_QUERY.addListener(onBreakpointChange);
  }
})();
